import { defineComponent as p, computed as c, defineAsyncComponent as n, openBlock as T, createBlock as a, resolveDynamicComponent as l, mergeProps as s } from "vue";
const S = /* @__PURE__ */ p({
  __name: "TnProductIcon",
  props: {
    name: {},
    size: { default: "m" }
  },
  setup(m) {
    const o = m, i = c(() => o.size === "xs" ? "48px" : o.size === "s" ? "64px" : o.size === "m" ? "96px" : o.size === "l" ? "120px" : o.size === "xl" ? "180px" : o.size === "2xl" ? "240px" : "96px"), r = {
      TnIcon2G: n(() => import("./TnIcon2-g-BpJkk5CP.js")),
      TnIcon3G: n(() => import("./TnIcon3-g-C-eKhxly.js")),
      TnIcon3GSIM: n(() => import("./TnIcon3-gsim-CRs41mUX.js")),
      TnIcon3GSIMInactive: n(() => import("./TnIcon3-gsim-inactive-DHZ2_wXN.js")),
      TnIcon4G: n(() => import("./TnIcon4-g-jbEkEzf-.js")),
      TnIcon4GPluss: n(() => import("./TnIcon4-g-pluss-Be_j26kB.js")),
      TnIcon4GSIM: n(() => import("./TnIcon4-gsim-CMhZwCCo.js")),
      TnIcon4GSIMGold: n(() => import("./TnIcon4-gsim-gold-BXNMNj5w.js")),
      TnIcon4GSIMinactive: n(() => import("./TnIcon4-gsi-minactive-BZFq1ZIQ.js")),
      TnIcon5G: n(() => import("./TnIcon5-g-DLnfgR8U.js")),
      TnIcon5GSIM: n(() => import("./TnIcon5-gsim-CYWh4Ozy.js")),
      TnIcon5GSIMinactive: n(() => import("./TnIcon5-gsi-minactive-B7G6yFC3.js")),
      TnIconAlltidpaNettGaranti: n(() => import("./TnIconalltidpa-nett-garanti-CxjjPHw4.js")),
      TnIconBedriftTale: n(() => import("./TnIconbedrift-tale-Dsbxvbm8.js")),
      TnIconBedriftTotal: n(() => import("./TnIconbedrift-total-b7aXm7FB.js")),
      TnIconBedriftTotalAnsatt: n(() => import("./TnIconbedrift-total-ansatt-BZVNva1C.js")),
      TnIconBedriftTotalY: n(() => import("./TnIconbedrift-total-y-CX_nV_Mh.js")),
      TnIconBetalSelvDataBoost: n(() => import("./TnIconbetal-selv-data-boost-BbH_1s3f.js")),
      TnIconBetalSelvDataBoostUtland: n(() => import("./TnIconbetal-selv-data-boost-utland-Cez6dyBz.js")),
      TnIconBetalSelvEkstraPakke: n(() => import("./TnIconbetal-selv-ekstra-pakke-WlBmP79a.js")),
      TnIconBetalSelvHastighet: n(() => import("./TnIconbetal-selv-hastighet-C2ndTFvB.js")),
      TnIconBlokkerAnrop: n(() => import("./TnIconblokker-anrop-Br0Cse2u.js")),
      TnIconBredbandstelefoni: n(() => import("./TnIconbredbandstelefoni-Bu6XQT8Z.js")),
      TnIconCustom: n(() => import("./TnIconcustom-HBeMxvz2.js")),
      TnIconDataBoost: n(() => import("./TnIcondata-boost-BDiaeg-Q.js")),
      TnIconDataBoostUtland: n(() => import("./TnIcondata-boost-utland-CNXIm0Mq.js")),
      TnIconDatagrense: n(() => import("./TnIcondatagrense-Hgmz9tAk.js")),
      TnIconDatakontroll: n(() => import("./TnIcondatakontroll-BumW4DS8.js")),
      TnIconDatakort: n(() => import("./TnIcondatakort-YOF77qys.js")),
      TnIconDataReload: n(() => import("./TnIcondata-reload-BNMI8PCh.js")),
      TnIconDataRollover: n(() => import("./TnIcondata-rollover-DYSZ0IAo.js")),
      TnIconDataSIM: n(() => import("./TnIcondata-sim-CQbscdKy.js")),
      TnIconDatasperreUtland: n(() => import("./TnIcondatasperre-utland-vicH65Cp.js")),
      TnIconEkstraPakke: n(() => import("./TnIconekstra-pakke-2Vgp51Sr.js")),
      TnIconEkstraSIM: n(() => import("./TnIconekstra-sim-EWWgxj0_.js")),
      TnIconEnkel8GB: n(() => import("./TnIconenkel8-gb-C3ER-QVv.js")),
      TnIconeSIM: n(() => import("./TnIcone-sim-9MmrSxWn.js")),
      TnIconEUInkludert: n(() => import("./TnIconeu-inkludert-BMSVsePA.js")),
      TnIconFallbackAgreements: n(() => import("./TnIconfallback-agreements-DgIHcV4O.js")),
      TnIconFallbackCoverage: n(() => import("./TnIconfallback-coverage-ddpD7U4I.js")),
      TnIconFallbackInternet: n(() => import("./TnIconfallback-internet-C_BFHo9t.js")),
      TnIconFallbackPhonePlan: n(() => import("./TnIconfallback-phone-plan-BQbSu-ta.js")),
      TnIconFallbackPhonePlanAddOn: n(() => import("./TnIconfallback-phone-plan-add-on-BiwhaR_x.js")),
      TnIconFallbackSIM: n(() => import("./TnIconfallback-sim-C4u6Vu8U.js")),
      TnIconFallbackSIMInactive: n(() => import("./TnIconfallback-sim-inactive-DlMR_4H3.js")),
      TnIconFallbackTelenorSpecific: n(() => import("./TnIconfallback-telenor-specific-lmqImjO3.js")),
      TnIconFamilie: n(() => import("./TnIconfamilie-Hn6yTVGK.js")),
      TnIconFamilieBonus: n(() => import("./TnIconfamilie-bonus-Dg5n9PCy.js")),
      TnIconFasttelefoni: n(() => import("./TnIconfasttelefoni-B5lcI4R9.js")),
      TnIconFiber: n(() => import("./TnIconfiber-CXM1hSit.js")),
      TnIconFleksi: n(() => import("./TnIconfleksi-BKstLa1i.js")),
      TnIconFlyt20: n(() => import("./TnIconflyt20-DINGJzGW.js")),
      TnIconFlyt5: n(() => import("./TnIconflyt5-djiZXfLy.js")),
      TnIconFlyt50: n(() => import("./TnIconflyt50-WxqsCDaJ.js")),
      TnIconFlytL: n(() => import("./TnIconflyt-l-3B163TZW.js")),
      TnIconFlytM: n(() => import("./TnIconflyt-m-vHgaEhxP.js")),
      TnIconFlytM20: n(() => import("./TnIconflyt-m20-B-b4nHc3.js")),
      TnIconFlytMPluss: n(() => import("./TnIconflyt-m-pluss-BBQF7IAj.js")),
      TnIconFlytS: n(() => import("./TnIconflyt-s-uTHIQHiF.js")),
      TnIconFlytXS: n(() => import("./TnIconflyt-xs-CsdoaTQa.js")),
      TnIconForhandler: n(() => import("./TnIconforhandler-CdTlYbcQ.js")),
      TnIconFornoydGaranti: n(() => import("./TnIconfornoyd-garanti-ayGD_dSc.js")),
      TnIconForsikring: n(() => import("./TnIconforsikring-BOsH-uZn.js")),
      TnIconFreebie: n(() => import("./TnIconfreebie-Bf7uhAM3.js")),
      TnIconFreeMMS: n(() => import("./TnIconfree-mms-BsAO-PBM.js")),
      TnIconFriBrukSkandinavia: n(() => import("./TnIconfri-bruk-skandinavia-DulSaS_V.js")),
      TnIconFrihet: n(() => import("./TnIconfrihet-DiXwCkYO.js")),
      TnIconFrihetBasis: n(() => import("./TnIconfrihet-basis-Dtu0E_Mr.js")),
      TnIconFrihetMaks: n(() => import("./TnIconfrihet-maks-C9E5E_Ib.js")),
      TnIconFrihetPremium: n(() => import("./TnIconfrihet-premium-DB6VmQnO.js")),
      TnIconFrihetStandard: n(() => import("./TnIconfrihet-standard-BOcB8N7W.js")),
      TnIconHastigheti24t: n(() => import("./TnIconhastigheti24t-DdU3ccmf.js")),
      TnIconHastigheti7Dager: n(() => import("./TnIconhastigheti7-dager-P-1aNLoW.js")),
      TnIconHastighetsreload24timer: n(() => import("./TnIconhastighetsreload24timer-CSWJez_8.js")),
      TnIconHastighetsreload7dager: n(() => import("./TnIconhastighetsreload7dager-WGffzbOU.js")),
      TnIconHastighetsreloadutmnd: n(() => import("./TnIconhastighetsreloadutmnd-JyPq9AXA.js")),
      TnIconHastighetutmnd: n(() => import("./TnIconhastighetutmnd-CwrUv1Tf.js")),
      TnIconIngenBinding: n(() => import("./TnIconingen-binding-BxgTpl22.js")),
      TnIconIngenTV: n(() => import("./TnIconingen-tv-Bhu7Ik0F.js")),
      TnIconKundeservice: n(() => import("./TnIconkundeservice-DCJ5dZ5n.js")),
      TnIconLegacy: n(() => import("./TnIconlegacy-Dgj8H3As.js")),
      TnIconLitt2GB: n(() => import("./TnIconlitt2-gb-CWAhSyOY.js")),
      TnIconLTEM: n(() => import("./TnIconltem-D1Yuutoq.js")),
      TnIconLTEMSIM: n(() => import("./TnIconltemsim-Q91KpMdf.js")),
      TnIconMer8GB: n(() => import("./TnIconmer8-gb-DXBaA9CZ.js")),
      TnIconMinBedrift: n(() => import("./TnIconmin-bedrift-B9bHq8ng.js")),
      TnIconMinimumData: n(() => import("./TnIconminimum-data-BBN_dU4L.js")),
      TnIconMinSky: n(() => import("./TnIconmin-sky-BNwkkruR.js")),
      TnIconMittTelenor: n(() => import("./TnIconmitt-telenor-wIeVd6ZR.js")),
      TnIconMixogMatch: n(() => import("./TnIconmixog-match-sNzRDcev.js")),
      TnIconMobbefilter: n(() => import("./TnIconmobbefilter-CExZxmBd.js")),
      TnIconMobiltBedriftsnett: n(() => import("./TnIconmobilt-bedriftsnett-DEK0a4E7.js")),
      TnIconMobiltBredband: n(() => import("./TnIconmobilt-bredband-BoJd4BXT.js")),
      TnIconMobiltSentralbord: n(() => import("./TnIconmobilt-sentralbord-CF1JNS7p.js")),
      TnIconMportShop: n(() => import("./TnIconmport-shop-Si5kfh3l.js")),
      TnIconNBIoT: n(() => import("./TnIconnb-io-t-DudoeJ6Z.js")),
      TnIconNbIoTSIM: n(() => import("./TnIconnb-io-tsim-CHuOVZV8.js")),
      TnIconNettslett: n(() => import("./TnIconnettslett-BzWJCAGK.js")),
      TnIconNettvern: n(() => import("./TnIconnettvern-BDausDH1.js")),
      TnIconNettvernPluss: n(() => import("./TnIconnettvern-pluss-NenREqEd.js")),
      TnIconNext: n(() => import("./TnIconnext-DbjiQY4D.js")),
      TnIconNextFamilie: n(() => import("./TnIconnext-familie-Vgu2XqSz.js")),
      TnIconNextFamilieRich: n(() => import("./TnIconnext-familie-rich-C75OoF2V.js")),
      TnIconNextMaksimal: n(() => import("./TnIconnext-maksimal-DYMs3dHz.js")),
      TnIconNextNormal: n(() => import("./TnIconnext-normal-B4UrlMth.js")),
      TnIconNextRask: n(() => import("./TnIconnext-rask-xMTIhfCv.js")),
      TnIconNextRich: n(() => import("./TnIconnext-rich-2J0oVlLQ.js")),
      TnIconNoData: n(() => import("./TnIconno-data-z-aqG3I2.js")),
      TnIconNummervarsel: n(() => import("./TnIconnummervarsel-DzabQ1YL.js")),
      TnIconOppdatert: n(() => import("./TnIconoppdatert-DPv3DbMh.js")),
      TnIconOrden: n(() => import("./TnIconorden-n4kIDgPF.js")),
      TnIconOriginal: n(() => import("./TnIconoriginal-CdzjQiYx.js")),
      TnIconOriginalRich: n(() => import("./TnIconoriginal-rich-BBOP4EGM.js")),
      TnIconPafyll: n(() => import("./TnIconpafyll-C5QMjP6C.js")),
      TnIconPlussforsikring: n(() => import("./TnIconplussforsikring-3YELi7HP.js")),
      TnIconPrepaidSIM: n(() => import("./TnIconprepaid-sim-BEg-LO0X.js")),
      TnIconRabatt: n(() => import("./TnIconrabatt-DNYT3ugN.js")),
      TnIconSAFE: n(() => import("./TnIconsafe-C9c6DQpw.js")),
      TnIconSAFEBasis: n(() => import("./TnIconsafe-basis-Doml49eh.js")),
      TnIconSAFEBasisIDvakt: n(() => import("./TnIconsafe-basis-i-dvakt-BPlcwXxP.js")),
      TnIconSAFEBasisSvindelforsikring: n(() => import("./TnIconsafe-basis-svindelforsikring-CD64hEdr.js")),
      TnIconSAFEBasisWiFi: n(() => import("./TnIconsafe-basis-wi-fi-CTeuzjFY.js")),
      TnIconSAFEIDvakt: n(() => import("./TnIconsafei-dvakt-C3iSofwR.js")),
      TnIconSAFEIDvaktKortovervakning: n(() => import("./TnIconsafei-dvakt-kortovervakning-BxF3DyUx.js")),
      TnIconSAFEIDvaktMailovervakning: n(() => import("./TnIconsafei-dvakt-mailovervakning-CXN7A5_r.js")),
      TnIconSAFEKredittvakt: n(() => import("./TnIconsafe-kredittvakt-i-GL8c8h.js")),
      TnIconSAFESvindelforsikring: n(() => import("./TnIconsafe-svindelforsikring-CNfimprF.js")),
      TnIconSAFEVPN: n(() => import("./TnIconsafevpn-C5bNm8y-.js")),
      TnIconSafeZone: n(() => import("./TnIconsafe-zone-BJZpS_KN.js")),
      TnIconSamletPlussforsikring: n(() => import("./TnIconsamlet-plussforsikring-Ds53KXYJ.js")),
      TnIconSeHvem: n(() => import("./TnIconse-hvem-gSBkBse5.js")),
      TnIconSikkerID: n(() => import("./TnIconsikker-id-DCafxVkA.js")),
      TnIconSkjermforsikring: n(() => import("./TnIconskjermforsikring-CcHqfker.js")),
      TnIconSmartFeilsoking: n(() => import("./TnIconsmart-feilsoking--VrO8U5z.js")),
      TnIconSvindelforsikringHusstand: n(() => import("./TnIconsvindelforsikring-husstand-DOOS3G7V.js")),
      TnIconSvindelforsikringIndivid: n(() => import("./TnIconsvindelforsikring-individ-W5T6jdi1.js")),
      TnIconSWAP: n(() => import("./TnIconswap-BaNCstLK.js")),
      TnIconTelefonsvar: n(() => import("./TnIcontelefonsvar-VVxlL2tt.js")),
      TnIconTelmi: n(() => import("./TnIcontelmi-CIQQFNzO.js")),
      TnIconTradlostBredband: n(() => import("./TnIcontradlost-bredband-DifXYeYr.js")),
      TnIconTryggStart: n(() => import("./TnIcontrygg-start-kAMdg_yg.js")),
      TnIconTvilling: n(() => import("./TnIcontvilling-CeVqj5Sf.js")),
      TnIconTvillingSIM: n(() => import("./TnIcontvilling-sim-I7d4ctwg.js")),
      TnIconTvillingSIMDisabled: n(() => import("./TnIcontvilling-sim-disabled-Cj8-hW2o.js")),
      TnIconTWe: n(() => import("./TnIcont-we-B7wJK0K5.js")),
      TnIconTWeSet: n(() => import("./TnIcont-we-set-CVPjcidI.js")),
      TnIconUbegrensetBasis: n(() => import("./TnIconubegrenset-basis-Cp2FnJz5.js")),
      TnIconUbegrensetMedium: n(() => import("./TnIconubegrenset-medium-CnfQAHFA.js")),
      TnIconUbegrensetPluss: n(() => import("./TnIconubegrenset-pluss-BewRYVtm.js")),
      TnIconWiFi: n(() => import("./TnIconwi-fi-D7TPB0_U.js")),
      TnIconWiFiModem: n(() => import("./TnIconwi-fi-modem-DTgk5N4V.js"))
    }, I = c(() => {
      if (!o.name) return null;
      const t = Object.keys(r).find((e) => e.toLowerCase() === `tnicon${o.name.toLowerCase().replace(/-/g, "")}`);
      return t ? r[t] : null;
    });
    return (t, e) => (T(), a(l(I.value), s({ fill: "none" }, t.$attrs, {
      height: i.value,
      width: i.value
    }), null, 16, ["height", "width"]));
  }
});
export {
  S as TnProductIcon
};
